import { createReducer } from 'typesafe-actions'
import {
  ReadSfWalletsRequestDto,
  ReadSfWalletsResponseDto,
  ReadUserSfWalletsResponseDto,
} from '@sparling/financial-common'
import { omit } from 'lodash'
import { ActionTypes } from '../types'
import { LoadingStateEnum } from '../../types'
import {
  getSfWalletsRequest,
  getSfWalletsSuccess,
  getSfWalletsFailure,
  getAssignedWalletsByUserRequest,
  getAssignedWalletsByUserSuccess,
  getAssignedWalletsByUserFailure,
  getAssignedWalletIdsByUserRequest,
  getAssignedWalletIdsByUserSuccess,
  resetSfWalletFilters,
} from '../actions'

const initialMetaState = {
  currentPage: 0,
  itemCount: 0,
  itemsPerPage: 0,
  totalItems: 0,
  totalPages: 0,
}

export type SfWalletsState = {
  loading: LoadingStateEnum
  data: ReadSfWalletsResponseDto
  filters: Partial<ReadSfWalletsRequestDto>
  error: Error | null
  assignedUserWallets: AssignedUserWallets
}

export type AssignedUserWallets = {
  idSf: string | null
  loading: LoadingStateEnum
  data: ReadUserSfWalletsResponseDto
  assignedIds: number[]
  error: Error | null
}

export const initialState = {
  loading: LoadingStateEnum.IDLE,
  data: {
    items: [],
    meta: initialMetaState,
  },
  filters: {},
  error: null,
  assignedUserWallets: {
    idSf: null,
    loading: LoadingStateEnum.IDLE,
    data: {
      items: [],
      meta: initialMetaState,
    },
    assignedIds: [],
    error: null,
  },
}

export const sfWallets = createReducer<SfWalletsState, ActionTypes>(initialState)
  .handleAction(getSfWalletsRequest, (state, { payload }) => ({
    ...state,
    filters: {
      ...state.filters,
      ...payload,
      page: Object.keys(omit(payload, 'page')).length > 0 ? 1 : payload.page,
    },
    loading: LoadingStateEnum.LOADING,
  }))
  .handleAction(getSfWalletsSuccess, (state, { payload }) => ({
    ...state,
    loading: LoadingStateEnum.SUCCESS,
    data: payload,
  }))
  .handleAction(getSfWalletsFailure, (state, { payload }) => ({
    ...state,
    loading: LoadingStateEnum.ERROR,
    error: payload,
  }))
  .handleAction(getAssignedWalletIdsByUserRequest, (state) => ({
    ...state,
    assignedUserWallets: {
      ...state.assignedUserWallets,
      assignedIds: [],
    },
  }))
  .handleAction(getAssignedWalletIdsByUserSuccess, (state, { payload }) => ({
    ...state,
    assignedUserWallets: {
      ...state.assignedUserWallets,
      assignedIds: payload,
    },
  }))
  .handleAction(getAssignedWalletsByUserRequest, (state, { payload: { idSf } }) => ({
    ...state,
    assignedUserWallets: {
      idSf,
      loading: LoadingStateEnum.LOADING,
      data: initialState.assignedUserWallets.data,
      assignedIds: initialState.assignedUserWallets.assignedIds,
      error: null,
    },
  }))
  .handleAction(getAssignedWalletsByUserSuccess, (state, { payload }) => ({
    ...state,
    assignedUserWallets: {
      ...state.assignedUserWallets,
      loading: LoadingStateEnum.SUCCESS,
      data: payload,
    },
  }))
  .handleAction(getAssignedWalletsByUserFailure, (state, { payload }) => ({
    ...state,
    assignedUserWallets: {
      ...state.assignedUserWallets,
      loading: LoadingStateEnum.ERROR,
      error: payload,
    },
  }))
  .handleAction(resetSfWalletFilters, (state) => ({
    ...state,
    filters: initialState.filters,
  }))
